import React from 'react'
import API from '../../services/API'
import Segment from '../../components/Segment'
import { Row, Divider, Col, Form, Typography, Button, Table, Badge } from 'antd'
import { Link } from 'react-router-dom'
import moment from 'moment'
import { currencyFormat, method } from '../../services/Utils'
const { Paragraph } = Typography

const columns = [
    {
        title: 'Denominación',
        dataIndex: 'denomination',
        key: 'denomination',
        render: text => currencyFormat(text),
    },
    {
        title: 'Tipo',
        dataIndex: 'type',
        key: 'type',
        render: text => (
            <Badge
                count={text === 'coin' ? 'Moneda' : 'Billete'}
                style={text === 'coin' ? { backgroundColor: '#faad14' } : { backgroundColor: '#105A37' }}
            />
        ),
    },
    {
        title: 'Cantidad',
        dataIndex: 'amount',
        key: 'amount',
    },
]

const parseCashDenomination = value => {
    if (!value) return []
    if (Array.isArray(value)) return value
    try {
        const parsed = JSON.parse(value)
        return Array.isArray(parsed) ? parsed : []
    } catch (error) {
        console.error('cash_denomination inválido:', value, error)
        return []
    }
}

const CashdrawalShowContainer = ({ match }) => {
    const [data, setData] = React.useState()
    const [loading, setloading] = React.useState(false)
    const [isOpen, setIsOpen] = React.useState(false)
    const handleClose = React.useCallback(() => setIsOpen(false), [])

    const getData = isMounted => {
        setloading(true)
        API.get(`/api/cash-withdrawals/${match.params.id}?with=user`)
            .then(response => {
                console.log('data', response.data.payload)
                if (!isMounted()) return
                setData(response.data.payload)
                setloading(false)
            })
            .catch(error => {
                console.log(error)
                if (!isMounted()) return
                setloading(false)
            })
    }

    React.useEffect(() => {
        let mounted = true
        getData(() => mounted)
        return () => {
            mounted = false
        }
    }, [])

    return (
        <Segment loading={loading}>
            <Divider>Detalle retiro de efectivo</Divider>
            <Form style={{ maxWidth: '500px', margin: 'auto' }} className="form-border">
                {!loading && data && (
                    <>
                        <Row gutter={24}>
                            <Col lg={12} md={12} sm={24}>
                                <Paragraph strong>Usuario en caja:</Paragraph>
                            </Col>
                            <Col lg={12} md={12} sm={24}>
                                <Paragraph>{data.user ? data.user.full_name : 'N/A'}</Paragraph>
                            </Col>
                        </Row>

                        <Row gutter={24}>
                            <Col lg={12} md={12} sm={24}>
                                <Paragraph strong>Receptor:</Paragraph>
                            </Col>
                            <Col lg={12} md={12} sm={24}>
                                <Paragraph>{data.receptor || 'N/A'}</Paragraph>
                            </Col>
                        </Row>

                        <Row gutter={24}>
                            <Col lg={12} md={12} sm={24}>
                                <Paragraph strong>Cantidad retirada:</Paragraph>
                            </Col>
                            <Col lg={12} md={12} sm={24}>
                                {currencyFormat(data.amount)}
                            </Col>
                        </Row>

                        <Row gutter={24}>
                            <Col lg={12} md={12} sm={24}>
                                <Paragraph strong>Razón:</Paragraph>
                            </Col>
                            <Col lg={12} md={12} sm={24}>
                                {data.cash_withdrawal_reason ? data.cash_withdrawal_reason.name : 'N/A'}
                            </Col>
                        </Row>

                        <Row gutter={24}>
                            <Col lg={12} md={12} sm={24}>
                                <Paragraph strong>Fecha:</Paragraph>
                            </Col>
                            <Col lg={12} md={12} sm={24}>
                                {moment(data.withdrawal_at).format('DD/MM/YYYY hh:mm A')}
                            </Col>
                        </Row>

                        <Row gutter={24}>
                            <Col lg={12} md={12} sm={24}>
                                <Paragraph strong>Turno:</Paragraph>
                            </Col>
                            <Col lg={12} md={12} sm={24}>
                                {data.shift_unique_id || 'N/A'}
                            </Col>
                        </Row>

                        <Row gutter={24}>
                            <Col lg={12} md={12} sm={24}>
                                <Paragraph strong>Caja:</Paragraph>
                            </Col>
                            <Col lg={12} md={12} sm={24}>
                                {data.checkout
                                    ? data.checkout.name
                                    : data.shift && data.shift.checkout
                                    ? data.shift.checkout.name
                                    : 'N/A'}
                            </Col>
                        </Row>

                        <Row gutter={24}>
                            <Col lg={12} md={12} sm={24}>
                                <Paragraph strong>Dinero retirado:</Paragraph>
                            </Col>
                            <Table
                                dataSource={parseCashDenomination(data.cash_denomination)}
                                columns={columns}
                                pagination={false}
                            />
                        </Row>
                    </>
                )}
            </Form>
            <Row type="flex" justify="center" style={{ marginTop: '50px' }}>
                <Form.Item>
                    <Link to={'/report/cash-withdrawal'} style={{ marginLeft: '5px' }}>
                        <Button icon="arrow-left">Regresar</Button>
                    </Link>
                </Form.Item>
            </Row>
        </Segment>
    )
}

export default CashdrawalShowContainer
